<template>
  <section role="region" class="how-can-we-help-section" ref="howCanWeHelpSection">
    <div class="content">
      <div class="image">
        <ThePicture mobilePath="/images/business/m-portal.png"
          desktopPath="/images/business/portal.png" mobileQuerie="833px" desktopQuerie="834px"
          altText="Moça sorrindo olhando para o lado" />
      </div>
      <div class="text">
        <TheSecondHead titleText="Como podemos te ajudar" chipColor="white" chipText="Nossa atuação" />
        <div class="text-columns">
          <div class="column-item" :class="makeFade ? 'show' : ''" v-for="feature in features" :key="feature.id"
            v-show="showTexts" :style="`transition-duration: ${feature.id * 0.4}s !important`">
            <h3 class="headline">{{ feature.title }}</h3>
            <p class="paragraph">{{ feature.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">

const features = ref<Array<ContentCardItem>>([
  {
    id: 1,
    title: 'Cobrança',
    text: 'Aumente a eficácia de pagamentos utilizando nossa régua de comunicação evolutiva.',
  },
  {
    id: 2,
    title: 'Fundos',
    text: 'Nossa régua de relacionamento atende aos mais variados tipos de ativos e portfólios.',
  },
  {
    id: 3,
    title: 'Consórcio',
    text: 'Réguas de boas-vindas, informe de datas de assembleias, avisos de lance e contemplação, lembretes de pagamento, avisos de atraso e muito mais.',
  },
  {
    id: 4,
    title: 'Seguros',
    text: 'Centralize toda a comunicação com os segurados. Papelaria, sinistro, valores a receber e ofertas de novos produtos.',
  },
  {
    id: 5,
    title: 'Onboarding',
    text: 'Transforme a experiência de seus clientes com comunicações personalizadas.',
  },
  {
    id: 6,
    title: 'Previdência',
    text: 'Informe, monitore e gerencie a comunicação com os participantes. Campanhas de adesão, retenção, informativos de valores a receber e muito mais.',
  },
])

const showTexts = ref<Boolean>(false);
const makeFade = ref<Boolean>(false);
const howCanWeHelpSection = ref<any>(null);

const howCanWeHelpWatcher = () => {
  var section = howCanWeHelpSection.value;

  if ((window.scrollY + section.offsetHeight) >= section.offsetTop) {
    setTimeout(() => {
      makeFade.value = true;
    }, 100);
    window.removeEventListener('scroll', howCanWeHelpWatcher);
  }
}

onMounted(() => {
  showTexts.value = true;
  window.addEventListener('scroll', howCanWeHelpWatcher, {passive: true});
  howCanWeHelpWatcher();
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', howCanWeHelpWatcher);
})
</script>

<style lang="scss">
.how-can-we-help-section {
  max-width: none;
  background: rgba(212, 213, 255, 0.50);

  .content {
    padding: 41px 19.5px 40px;

    .image {
      text-align: center;

      .image-component img {
        margin-bottom: 40px;
        width: 100%;
        max-width: 500px;
      }
    }

    .text {
      max-width: 522px;
      margin: 0px auto;

      .headline {
        .title {
          margin: 16px 0px 32px;
          font-size: 40px;
          padding-right: 8px;
          line-height: 110%;
        }
      }

      .text-columns {
        .column-item:not(:last-child) {
          margin-bottom: 32px;
        }
      }
    }

    @media screen and (min-width: 363px) and (max-width: 409px) {
      .text .headline .title {
        width: 88%;
      }
    }

    @media screen and (min-width: 410px) and (max-width: 445px) {
      .text .headline .title {
        width: 80%;
      }
    }

    @media screen and (min-width: 446px) and (max-width: 495px) {
      .text .headline .title {
        width: 70%;
      }
    }

    @media screen and (min-width: 834px) and (max-width: 959px) {
      .image {
        .image-component img {
          margin-bottom: 68px;
        }
      }
    }

    @media screen and (min-width: 960px) and (max-width: 1199px) {
      padding: 78px 12px 68px 32px;
      justify-content: space-between;
      column-gap: 51px;

      .text {
        max-width: 518px;
      }
    }

    @media screen and (min-width: 834px) {
      .text {
        .text-columns {
          display: grid;
          grid-auto-flow: column;
          grid-template-rows: auto auto auto;
          column-gap: 54px;

          .column-item:nth-child(3) {
            margin-bottom: 0px;
          }
        }

      }

    }

    @media screen and (min-width: 960px) {
      display: flex;
      align-items: flex-end;
      max-width: 1058px;
      margin: 0 auto;

      .image {
        .image-component img {
          margin-bottom: 0px;
          max-width: 430px;
        }
      }

      .text {
        margin: 0px;

        .text-columns {
          .column-item {
            &:nth-child(1) {
              width: 216px;
            }

            &:nth-child(2) {
              width: 189px;
            }

            &:nth-child(3) {
              width: 212px
            }

            &:nth-child(4) {
              width: 248px;
            }

            &:nth-child(5) {
              width: 202px;
            }

            &:nth-child(6) {
              width: 230px;
            }
          }
        }
      }
    }

    @media screen and (min-width: 1200px) {
      column-gap: 100px;
      justify-content: center;
      margin: 0 auto;
      padding: 78px 0px 68px;
      align-items: flex-start;
    }
  }

  // Animação de aparecer
  .column-item {
    opacity: 0;
    -webkit-transform: translateY(54px);
    transform: translateY(54px);
  }

  .show {
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
    opacity: 1;
  }

  // Fim animação de aparecer
}
</style>